import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { handleLeftSideBar } from "../redux/app/actions";
import LeftBarSports from "../views/components/LeftBarSports";

import MainIcon from "../assets/images/icons/bottom-menu/betslip.webp";
import SportsIcon from "../assets/images/icons/bottom-menu/sports-icon.webp";
import ESportsIcon from "../assets/images/icons/bottom-menu/Popular.webp";
import CasinoIcon from "../assets/images/icons/bottom-menu/sportsIcon.webp";
import LiveCasinoIcon from "../assets/images/icons/bottom-menu/history.webp";
import MenuIcon from "../assets/images/icons/bottom-menu/Menu.webp";
import { APP_CONST, SportsLobbyProviders } from "../config/const";
import ModalWrapper from "./ModalWrapper";

export default function BottomNav() {
  const { isAuth } = useSelector((state) => state.auth);
  const location = useLocation();
  const [activePage, setActivePage] = useState("");
  const dispatch = useDispatch();
  const { showLeftSideBar } = useSelector((state) => state.app);
  const htmlElement = document.documentElement;
  const [showAuthModals, setShowAuthModals] = useState(false);
  const [defaultModal, setDefaultModal] = useState("login");

  useEffect(() => {
    if (showLeftSideBar) {
      htmlElement.style.overflow = "hidden";
      document.body.classList.add("leftbar-opened");
    } else {
      htmlElement.style.overflow = "auto";
      document.body.classList.remove("leftbar-opened");
    }
  }, [showLeftSideBar]);

  const footerPages = [
    "/home",
    `/sports-lobby/${SportsLobbyProviders.IgPixel}`,
    "/mybets",
    "/mybets?type=sports",
    "/dashboard",
    "/",
  ];

  useEffect(() => {
    const { pathname, search } = location;

    let matchedValue = footerPages.find((f) => f === pathname);
    // Special handling for /mybets with query params
    if (pathname === "/mybets" && search) {
      if (search.includes("type=sports")) {
        matchedValue = "/mybets?type=sports";
      }
    }
    // all other pathnames
    if (!matchedValue && pathname === "/") {
      matchedValue = "/";
    }

    if (matchedValue) {
      setActivePage(matchedValue);
    }
  }, [location]);

  const handleModalShow = (modalName) => {
    setShowAuthModals(true);
    setDefaultModal(modalName);
  };

  return (
    <>
      <div className="footer-menu position-fixed start-0 bottom-0 z-index-2 d-block d-md-none">
        <ul className="d-flex justify-content-evenly m-0 p-0 list-unstyled">
          <li>
            <a
              className={
                activePage === "/home" || activePage === "/" ? "active" : ""
              }
              href={isAuth ? "/home" : "/"}
            >
              <div className="imgBox">
                <img src={ESportsIcon} alt="SportsIcon" />
              </div>
              <span>Popular</span>
            </a>
          </li>
          <li>
            <a
              href={`/sports-lobby/${SportsLobbyProviders.IgPixel}?lang=ru`}
              className={
                activePage === `/sports-lobby/${SportsLobbyProviders.IgPixel}`
                  ? "active"
                  : ""
              }
            >
              <div className="imgBox">
                <img src={CasinoIcon} alt="SportsIcon" />
              </div>
              <span>Sports</span>
            </a>
          </li>
          <li>
            <a
              className={
                activePage === "/" || activePage === "/mybets" ? "active" : ""
              }
              href="/mybets"
            >
              <div className="imgBox bets">
                <img src={MainIcon} alt="SportsIcon" />
              </div>
              <span>Bet Slip</span>
            </a>
          </li>

          <li>
            <a
              className={activePage === "/mybets?type=sports" ? "active" : ""}
              href="/mybets?type=sports"
            >
              <div className="imgBox">
                <img src={LiveCasinoIcon} alt="SportsIcon" />
              </div>
              <span>History</span>
            </a>
          </li>
          {isAuth ? (
            <li>
              <a
                className={activePage === "/dashboard" ? "active" : ""}
                href="/dashboard"
              >
                <div className="imgBox">
                  <img src={MenuIcon} alt="SportsIcon" />
                </div>
                <span>Menu</span>
              </a>
            </li>
          ) : (
            <li>
              <a
                onClick={() => {
                  handleModalShow(APP_CONST.AUTH_MODAL.LOGIN);
                }}
              >
                <div className="imgBox">
                  <img src={MenuIcon} alt="SportsIcon" />
                </div>
                <span>Menu</span>
              </a>
            </li>
          )}
        </ul>
      </div>

      <LeftBarSports />

      {showAuthModals && (
        <ModalWrapper
          defaultShow={defaultModal}
          handleClose={setShowAuthModals}
        />
      )}
    </>
  );
}
